export default __webpack_public_path__ + "static/media/Countdown_1.2fc2a580.svg";